module.exports = __webpack_public_path__ + "img/20190620162200526.0520a663.png";